<template>
	<v-tooltip top>
		<v-btn
			flat
			icon
			class="action-icon-button ma-0"
			:class="{ 'is-edit-action': isEditAction }"
			:aria-label="text"
			slot="activator"
			small
			:color="buttonColor"
			@click.prevent="clickIcon"
			:disabled="disabled"
		>
			<v-icon v-bind:style="isListAll">{{ icon }}</v-icon>
		</v-btn>
		<span>{{ text }}</span>
	</v-tooltip>
</template>

<script>

function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

export default {
	name: 'app-tooltip-button',
	computed: {
		buttonColor,
		isEditAction,
		isListAll,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'green',
		},
		icon: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
	},
	methods: {
		clickIcon,
	},
};
</script>

<style lang="scss" scoped>
.action-icon-button {
	background: #f2f6f9 !important;
	border: 1px solid transparent;
	border-radius: 7px;
	height: 28px;
	min-width: 28px;
	transition: background .16s ease, border-color .16s ease, transform .16s ease;
	width: 28px;

	.icon {
		font-size: 17px;
	}

	&:hover {
		background: #EAF3EF !important;
		border-color: #C8DDD5;
		transform: translateY(-1px);
	}

	&.is-edit-action:hover {
		background: #EAF3FA !important;
		border-color: #BED8EA;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-tooltip-button.vue